import React from 'react';
import styles from './EnergyPageCustom_Kratos.module.css'
import DashboardMain_Kratos from '../DashboardMain_Kratos/DashboardMain_Kratos';
import * as $ from 'jquery';
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_kratos';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_kratos';
import useHttp from '../../../hook/use-http'
import ThreeGaugeChart_Kratos from './ThreeGaugeChart_Kratos';
import ConsumptionTables_Kratos from './ConsumptionTables_Kratos';
import Energyanalysis_Filters_Kratos from './Energyanalysis_Filters_Kratos';
import { decodeToken } from 'react-jwt';
import PieChartAm from './PieChartAm';
import HorizontalBarchart from './HorizontalBarchart';
import Energy_Consumption_Breakdown from './Energy_Consumption_Breakdown';
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice";
import ConsumptionTables_FleetEv_Kratos from "./Energyanalysis_FleetEV_Kratos/ConsumptionTables_FleetEv_Kratos"

export default function Energyanalysis_Kratos() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE
  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const log_data = (data) => {
  }

  useEffect(() => {
    window.$("#button-1_Kratos").checked = false
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "energyanalysis_kratos"
      }
    }, log_data)
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setFromTableToFilter_vin(vin_num[0])
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <DashboardMain_Kratos>
        <div className={`${styles.main_hole_background}`}>
          <Energyanalysis_Filters_Kratos onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
          <div className="container-fluid">
            <section className="kpi my-3">
              <div className="row">
                <div className="col-md-8 col-sm-12 col-lg-8">
                  <ThreeGaugeChart_Kratos gloablfilter={gloablfilter} />
                  {(loggedInUser.flagForHideShow === "ERC") ?
                  <ConsumptionTables_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                  :
                  <ConsumptionTables_FleetEv_Kratos gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
                  }
                </div>
                <div className="col-md-4 col-sm-12 col-lg-4">
                  <PieChartAm gloablfilter={gloablfilter} />
                </div>
              </div>
            </section>
            <section className="kpi my-3">
              <div className="row pr-3">
                {/* <div className='col-md-5'> */}
                <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-5' : 'col-md-3')} >
                  <HorizontalBarchart gloablfilter={gloablfilter} />
                </div>
                <div className={(loggedInUser.flagForHideShow === "ERC" ? 'col-md-7 energyChartboxNew_Kratos' : 'col-md-9 energyChartboxNew_Kratos')}>
                  <Energy_Consumption_Breakdown gloablfilter={gloablfilter} />
                </div>
              </div>
            </section>
          </div>
        </div>
      </DashboardMain_Kratos >
    </>
  )
}